import React from 'react';
import GamesState from './gamesState/GamesState';
import GamesControlPanel from './components/GamesControlPanel/GamesControlPanel';
import Games from './components/Games/Games';
import { ModalWindows } from './components/ModalWindows';
import style from './index.module.scss';

const GamesPage: React.FC = () => {
	return (
		<GamesState>
			<div className={style.container} data-test="GamesPage">
				<GamesControlPanel />
				<Games />
				<ModalWindows />
			</div>
		</GamesState>
	);
};

export default GamesPage;
